import { combineReducers } from 'redux';

import agentProfileReducer from 'agent-profile/agentProfileReducer';
import applicationsDashboardReducer from 'applications-dashboard/applicationsDashboardReducer';
import appReducer from './appReducer';

export default combineReducers({
  app: appReducer,
  agentProfile: agentProfileReducer,
  dashboard: applicationsDashboardReducer,
});
